<template>
  <div class="m-edition-billing-modify-password">
    <form
      autocomplete="off"
      @submit.prevent="changePassword"
    >
      <div
        :class="`margin-bottom-xxlarge a-alert ${message.class}`"
        v-if="message.show"
      >
        <span class="a-alert-message">
          {{ message.text }}
        </span>
        <a
          class="a-alert-primary-close"
          href="cerrar"
          @click.prevent="closeAlert"
        >
          <i class="fas fa-times"></i>
        </a>
      </div>

      <AtomInputPrimary
        v-model="usuario.email"
        label="Email de Usuario"
        required
      />

      <AtomInputPrimary
        v-model="usuario.password"
        label="Nueva Contraseña"
        message="* Mínimo: 8 caracteres, una letra minúscula, una mayúscula y un número"
      />

      <AtomButtonPrimary :button-primary="buttonPrimary" />
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingModifyPassword',

  data () {
    return {
      buttonPrimary: {
        action: 'GUARDAR',
        behavior: 'save',
        sending: false,
        type: 'submit'
      },

      message: {
        class: '',
        text: '',
        show: false
      },

      usuario: {
        email: '',
        password: ''
      }
    }
  },

  methods: {
    changePassword () {
      this.buttonPrimary.sending = true
      this.message.show = false
      this.$services.create('usuario', 'createUsuarioResetPasswordManual', this.usuario)
        .then(response => {
          let cognito = response.data
          console.log(cognito)
          if (!cognito.error) {
            this.message.class = 'a-alert-success'
            this.message.text = this.$t('mEditionBillingModifyPassword.alerts.messageSuccess') + cognito.password
            this.message.show = true
          } else {
            this.buttonPrimary.sending = false
            this.message.class = 'a-alert-danger'
            this.message.text = cognito.message
            this.message.show = true
          }
          this.buttonPrimary.sending = false
        })
        .catch(error => {
          console.log(error)
          this.message.class = 'a-alert-warning'
          this.message.text = this.$t('mEditionBillingModifyPassword.alerts.messageError')
          this.message.show = true
          this.buttonPrimary.sending = false
        })
    },

    closeAlert () {
      this.message.show = false
    }
  }
}
</script>
